import { windowRegistry } from './WindowRegistry';
import type { WindowPoint, WindowSize } from './types';

export interface WindowFrameOptions {
    windowId: string;
    container: HTMLDivElement;
    header: HTMLDivElement;
    resizeHandle?: HTMLDivElement;
    closeButton?: HTMLButtonElement;
    minWidth: number;
    minHeight: number;
    initialPosition: WindowPoint;
    initialSize: WindowSize;
    persistState?: boolean;
}

export interface WindowFrameHandle {
    getWindowState(): 'open' | 'minimized' | 'closed';
    setWindowState(state: 'open' | 'minimized' | 'closed'): void;
    getActiveTab(): string;
    setActiveTab(tab: string): void;
    destroy(): void;
}

export function createWindowFrame(options: WindowFrameOptions): WindowFrameHandle {
    const handle = windowRegistry.register({
        id: options.windowId,
        container: options.container,
        header: options.header,
        resizeHandle: options.resizeHandle,
        closeButton: options.closeButton,
        minWidth: options.minWidth,
        minHeight: options.minHeight,
        defaultPosition: options.initialPosition,
        defaultSize: options.initialSize,
        persistState: options.persistState,
    });
    return {
        getWindowState: () => handle.getWindowState(),
        setWindowState: (state) => handle.setWindowState(state),
        getActiveTab: () => handle.getActiveTab(),
        setActiveTab: (tab) => handle.setActiveTab(tab),
        destroy(): void {
            handle.destroy();
        },
    };
}
